import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["grid", "jsonMode", "tbody", "hiddenInput", "jsonInput", "columnsList"]

  connect() {
    this._readColumnsFromDOM()
  }

  _readColumnsFromDOM() {
    this.columns = []
    this.columnsListTarget.querySelectorAll(".column-row").forEach(row => {
      const label = row.querySelector("[data-field='label']")?.value || ""
      const key = row.querySelector("[data-field='key']")?.value || ""
      const type = row.querySelector("[data-field='type']")?.value || "text"
      if (key) this.columns.push({ key, label, type, width: "25%", align: "left" })
    })
  }

  onInput(event) {
    this._syncToJson()
  }

  addColumn() {
    const idx = this.columnsListTarget.querySelectorAll(".column-row").length
    const key = `col${idx + 1}`
    const div = document.createElement("div")
    div.className = "flex gap-2 items-center column-row"
    div.innerHTML = `
      <input type="text" value="Колонка ${idx + 1}" data-field="label" placeholder="Заголовок" class="text-xs border rounded px-1 py-0.5 flex-1">
      <input type="text" value="${key}" data-field="key" placeholder="Ключ" class="text-xs border rounded px-1 py-0.5 w-20">
      <select data-field="type" class="text-xs border rounded px-1 py-0.5 w-20">
        <option value="text" selected>text</option>
        <option value="number">number</option>
      </select>
      <button type="button" data-action="dae20--user-table-editor#removeColumn" class="text-red-400 hover:text-red-600 text-xs px-1">×</button>
    `
    this.columnsListTarget.appendChild(div)
    this._readColumnsFromDOM()
    this._rebuildHeader()
    this._rebuildGridBody()
    this._syncToJson()
  }

  removeColumn(event) {
    const row = event.target.closest(".column-row")
    if (row) {
      row.remove()
      this._readColumnsFromDOM()
      this._rebuildHeader()
      this._rebuildGridBody()
      this._syncToJson()
    }
  }

  addRow() {
    if (this.columns.length === 0) {
      alert("Сначала добавьте колонки")
      return
    }

    const tr = document.createElement("tr")
    let html = `<td class="px-1 py-0.5 text-center"><button type="button" data-action="dae20--user-table-editor#deleteRow" class="text-red-400 hover:text-red-600">×</button></td>`

    this.columns.forEach(col => {
      const type = col.type === "number" ? "number" : "text"
      const step = col.type === "number" ? ' step="any"' : ""
      const cls = col.type === "number" ? "w-full px-1 py-0.5 border rounded text-xs font-mono" : "w-full px-1 py-0.5 border rounded text-xs"
      html += `<td class="px-1 py-0.5"><input type="${type}"${step} data-col="${col.key}" data-action="input->dae20--user-table-editor#onInput" value="" class="${cls}"></td>`
    })

    tr.innerHTML = html
    this.tbodyTarget.appendChild(tr)
    this._syncToJson()
  }

  deleteRow(event) {
    const row = event.target.closest("tr")
    if (row) {
      row.remove()
      this._syncToJson()
    }
  }

  toggleJson() {
    this.gridTarget.classList.toggle("hidden")
    this.jsonModeTarget.classList.toggle("hidden")

    if (!this.jsonModeTarget.classList.contains("hidden")) {
      this.jsonInputTarget.value = this.hiddenInputTarget.value
    } else {
      try {
        const data = JSON.parse(this.jsonInputTarget.value)
        this.columns = data.columns || []
        this._rebuildColumnsList()
        this._rebuildHeader()
        this._rebuildGridBodyFromData(data)
        this._syncToJson()
      } catch (e) {
        alert("Невалидный JSON: " + e.message)
      }
    }
  }

  _rebuildColumnsList() {
    this.columnsListTarget.innerHTML = ""
    this.columns.forEach((col, idx) => {
      const div = document.createElement("div")
      div.className = "flex gap-2 items-center column-row"
      div.innerHTML = `
        <input type="text" value="${col.label || ""}" data-field="label" placeholder="Заголовок" class="text-xs border rounded px-1 py-0.5 flex-1">
        <input type="text" value="${col.key || ""}" data-field="key" placeholder="Ключ" class="text-xs border rounded px-1 py-0.5 w-20">
        <select data-field="type" class="text-xs border rounded px-1 py-0.5 w-20">
          <option value="text" ${col.type === "text" ? "selected" : ""}>text</option>
          <option value="number" ${col.type === "number" ? "selected" : ""}>number</option>
        </select>
        <button type="button" data-action="dae20--user-table-editor#removeColumn" class="text-red-400 hover:text-red-600 text-xs px-1">×</button>
      `
      this.columnsListTarget.appendChild(div)
    })
  }

  _rebuildHeader() {
    const thead = this.gridTarget.querySelector("thead tr")
    if (!thead) return
    thead.innerHTML = '<th class="px-1 py-1 w-8"></th>'
    this.columns.forEach(col => {
      thead.innerHTML += `<th class="px-1 py-1 text-left font-medium text-gray-600 border-b header-cell">${col.label || col.key}</th>`
    })
  }

  _rebuildGridBody() {
    this.tbodyTarget.innerHTML = ""
  }

  _rebuildGridBodyFromData(data) {
    this.tbodyTarget.innerHTML = ""
    const rows = data.rows || []
    rows.forEach(row => {
      const tr = document.createElement("tr")
      let html = `<td class="px-1 py-0.5 text-center"><button type="button" data-action="dae20--user-table-editor#deleteRow" class="text-red-400 hover:text-red-600">×</button></td>`
      this.columns.forEach(col => {
        const type = col.type === "number" ? "number" : "text"
        const step = col.type === "number" ? ' step="any"' : ""
        const cls = col.type === "number" ? "w-full px-1 py-0.5 border rounded text-xs font-mono" : "w-full px-1 py-0.5 border rounded text-xs"
        const val = row[col.key] || ""
        html += `<td class="px-1 py-0.5"><input type="${type}"${step} data-col="${col.key}" data-action="input->dae20--user-table-editor#onInput" value="${val}" class="${cls}"></td>`
      })
      tr.innerHTML = html
      this.tbodyTarget.appendChild(tr)
    })
  }

  _syncToJson() {
    this._readColumnsFromDOM()

    const rows = []
    this.tbodyTarget.querySelectorAll("tr").forEach(tr => {
      const row = {}
      tr.querySelectorAll("input[data-col]").forEach(input => {
        const key = input.dataset.col
        const val = input.value
        if (val === "") {
          row[key] = null
        } else if (input.type === "number") {
          row[key] = parseFloat(val) || 0
        } else {
          row[key] = val
        }
      })
      if (Object.keys(row).length > 0) rows.push(row)
    })

    const data = {
      version: "1.0",
      meta: { title: "" },
      columns: this.columns,
      rows: rows
    }

    this.hiddenInputTarget.value = JSON.stringify(data)
    if (this.hasJsonInputTarget) {
      this.jsonInputTarget.value = JSON.stringify(data, null, 2)
    }
  }
}
